
        <div class="detalle__movimiento">
            <div class="detalle__title-2">
                <h2>Puntos de Venta</h2>
                <div class="btn-group">
                    <label>Buscar</label>
                    <input type="text" [(ngModel)]="filter" placeholder="Ingrese búsqueda" [attr.disabled]="error ? true : loading ? true : null">
                </div>
            </div>
            <div class="movimientos movimientosComponent">
                <div  class="movimientos__items">
                    <div>
                        <h2>Municipio</h2>
                    </div>
                    <div>
                        <h2>Zona</h2>
                    </div>
                    <div>
                        <h2>Dirección</h2>
                    </div>
                    <div>
                        <h2>Comercio</h2>
                    </div>
                    <div>
                        <h2>Punto de Referencia</h2>
                    </div>
                </div>                    
                <div *ngIf="error" class="alert red"><p>{{ msjError }}</p></div>
                <ng-container *ngIf="(pVenta | filterPVenta:filter) as result">
                    <div *ngIf="result.length < 1" class="alert red"><p>No se encontraron registros</p></div>

                    <div  *ngFor="let data of result; let i = index" class="movimientos__items content">
                        <div class="body">
                            <h2>Municipio</h2>
                            <p>{{data.desLargo01}}</p>
                        </div>
                        <div class="body">
                            <h2>Zona</h2>
                            <p>{{data.desLargo02}}</p>
                        </div>
                        <div class="body">
                            <h2>Dirección</h2>
                            <p>{{data.desLargo03}}</p>
                        </div>
                        <div class="body">
                            <h2>Comercio</h2>
                            <p>{{data.desLargo04}}</p>
                        </div>
                        <div class="body">
                            <h2>Punto de referencia</h2>
                            <p>
                                {{data.desLargo05}}
                            </p>
                        </div>
                </div>
            </ng-container>
            </div>
        </div>